(function() {
	'use strict';

	angular
		.module('pwc.services.connection')
		.service('ConnectionService', ConnectionService);

	ConnectionService.$inject = ['$window', '$mdToast', 'userPouch', 'systemPouch'];

	function ConnectionService($window, $mdToast, userPouch, systemPouch){

		var ApiURL = 'https://api.personalwinecurator.com/v1/heartbeat';

		var connectionMonitor = null;

		function getOptions() {
			return {
				checkOnLoad: true,
				interceptRequests: true,
				reconnect: {
					initialDelay: 3
				},
				requests: false,
				checks: {
					xhr: {
						url: ApiURL
					}
				}
			};
		}

		function onConnectionUp(){
			$mdToast.show(
				$mdToast.simple()
					.content('Back online!')
					.position("top right")
					.hideDelay(5000)
			);
			$log.debug('Connection is now up...');
			//userPouch.startReplication();
			//systemPouch.startReplication();
		}

		function onConnectionDown(){
			$mdToast.show(
				$mdToast.simple()
					.content('You have gone offline!')
					.position("top right")
					.hideDelay(0)
			);
			$log.debug('Connection is now down...');
			userPouch.cancelReplication();
			systemPouch.cancelReplication();
		}

		function initialize(){

			connectionMonitor = $window.Offline;

			connectionMonitor.options = getOptions();

			connectionMonitor.on('up', onConnectionUp);

			connectionMonitor.on('down', onConnectionDown);
		}

		// exposed, public API
		return {
			initialize: initialize
		};

	}

})();
